import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FitnessPanel = ({ setShowRegisterNewCustomer, setShowMemberFinder }) => {
  const [currentTime, setCurrentTime] = useState(new Date());
    const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatDateTime = (date) => {
    const options = {
      weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: true,
    };
    return date.toLocaleString('en-US', options);
  };

  const handleStartSession = () => {
    navigate('/gym-finder');
  }

  return (
    <div className="col-lg-4 mb-4 pr-4">
      <h1 className="display-5 mb-3">
        Manage your <span className="text-success">Fitness</span> business
      </h1>
      <p className="text-muted">{formatDateTime(currentTime)}</p>

      <button
        className="btn btn-success btn-block mb-2"
        onClick={handleStartSession}
      >
        <i className="fa fa-play mr-2"></i> Start Gym Session
      </button>

      <button
        className="btn btn-outline-primary btn-block"
        onClick={() => setShowRegisterNewCustomer(true)}
      >
        <i className="fa fa-plus mr-2"></i> New Customer
      </button>
    </div>
  );
};

export default FitnessPanel;
